import axios from 'axios';

export interface SearchKeywordStat {
  keyword: string;
  count: number;
}

export interface SearchStats {
  searchesLast7Days: number;
  searchesLast30Days: number;
  desktopSearchesLast30Days: number;
  mobileSearchesLast30Days: number;
  topKeywords: SearchKeywordStat[];
  zeroResultKeywords: SearchKeywordStat[];
}

export const getSearchStats = async (token: string) => {
  const response = await axios.get('/api/search/stats', {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data as SearchStats;
};
